import { render, staticRenderFns } from "./PacienteBuscaEntrega.vue?vue&type=template&id=736add64&"
import script from "./PacienteBuscaEntrega.vue?vue&type=script&lang=js&"
export * from "./PacienteBuscaEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports